import { sanitizeMessage, sanitizeToText } from '@/shared/utils/sanitize'

type CopyRichTextParams = {
  plainText: string
  html?: string
}

const toClipboardHtml = (html: string): string => {
  return sanitizeMessage(html.replace(/\r\n|\r|\n/g, '<br>'))
}

export const copyRichTextToClipboard = async ({
  plainText,
  html,
}: CopyRichTextParams): Promise<void> => {
  const plain = sanitizeToText(plainText)
  const richHtml = html ? toClipboardHtml(html) : ''

  if (!richHtml || richHtml === plain) {
    await navigator.clipboard.writeText(plain)
    return
  }

  if (!navigator.clipboard?.write || typeof ClipboardItem === 'undefined') {
    await navigator.clipboard.writeText(plain)
    return
  }

  await navigator.clipboard.write([
    new ClipboardItem({
      'text/plain': new Blob([plain], { type: 'text/plain' }),
      'text/html': new Blob([richHtml], { type: 'text/html' }),
    }),
  ])
}
